<div class="not-found">
    <section class="not-found-description">
        <h1>¡Oops!</h1>
        <h3>Acceso denegado.</h3>
        <p>Es posible que no tenga permisos para acceder a este tipo de solicitud, sera redirigido al inicio.</p>
        <a class="btn btn-primary" href="/panel">Regresar al inicio</a>
    </section>
    <img src="assets/images/Inscripcion-clave-dinamica2.svg" alt="Página no encontrada" />
</div>